import React from "react";

const ClickableAreaRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 9.25V5.75C17.25 4.09315 15.9069 2.75 14.25 2.75H5.75C4.09315 2.75 2.75 4.09315 2.75 5.75V14.25C2.75 15.9069 4.09315 17.25 5.75 17.25H7.25",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.875 17.25L9.75 8.75L17.25 13.0278L13.5 14.0278L11.875 17.25Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ClickableAreaRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;